import img from '../../assets/mason-kim.jpg';

const Mason = {
  name: 'Mason Kim',
  bio: "Sales. Fun fact: Mason will eat his vegetables, but he has no idea that cashews grow on trees and strawberries aren't really berries, but bananas are berries. Look it up.",
  url: 'mason',
  img,
};

export default Mason;
